"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var api_request_1 = require("../api_request");
var comparison_shopping_page_1 = require("../discovery/csp/comparison_shopping_page");
var url_helpers_1 = require("../shared/url_helpers");
var csp_square_card_1 = require("../discovery/csp/csp_square_card");
var overflowing_row_1 = require("@reverbdotcom/commons/dist/components/overflowing_row");
var tiles_1 = require("@reverbdotcom/commons/dist/components/tiles");
var COMPONENT_NAME = 'CSPMiniGrid';
var CSPMiniGridEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(CSPMiniGridEmbed, _super);
    function CSPMiniGridEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pages: [],
        };
        return _this;
    }
    CSPMiniGridEmbed.prototype.componentDidMount = function () {
        var _this = this;
        var req = api_request_1.V3.get(url_helpers_1.default.cspsEmbedPath(), {
            curated_set_slug: this.props.slug,
            per_page: 6,
        });
        req.then(function (response) {
            var pages = response
                .comparison_shopping_pages
                .map(function (page) { return new comparison_shopping_page_1.default(page); });
            _this.setState({ pages: pages });
        });
    };
    CSPMiniGridEmbed.prototype.collectionLink = function () {
        return (React.createElement("a", { href: "/collection/" + this.props.slug }, I18n.t('discovery.cspMiniGridEmbed.seeMore')));
    };
    CSPMiniGridEmbed.prototype.render = function () {
        return (React.createElement(overflowing_row_1.default, { title: this.props.heading, action: this.collectionLink(), collectionCount: this.state.pages.length },
            React.createElement(tiles_1.default, { placeholder: React.createElement(csp_square_card_1.default, null), singleRow: true }, this.state.pages.map(function (page, idx) { return (React.createElement(csp_square_card_1.default, { trackName: COMPONENT_NAME, key: idx, page: page, position: idx + 1 })); }))));
    };
    return CSPMiniGridEmbed;
}(React.Component));
exports.default = CSPMiniGridEmbed;
//# sourceMappingURL=csp_mini_grid_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/csp_mini_grid_embed.js
// module id = JnMi
// module chunks = 20 21